import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { IotaAppStores } from '../../stores';
import { STORE_PROJECT_APPLICATION_DEFINITION_SOURCES } from '../../stores/constants';
import ApplicationInternalSelectInput from './ApplicationInternalSelectInput';

type BaseProps = React.ComponentProps<typeof ApplicationInternalSelectInput>;
type Props = Omit<BaseProps, 'sourcesStore'> & IotaAppStores;

const ApplicationInternalSelectInputWrapper: React.FC<Props> = ({
    projectApplicationDefinitionsSourcesUI: sourcesStore,
    ...props
}) => {
    if (!sourcesStore) {
        return null;
    }

    return <ApplicationInternalSelectInput {...props} sourcesStore={sourcesStore} />;
};

export default inject(STORE_PROJECT_APPLICATION_DEFINITION_SOURCES)(observer(ApplicationInternalSelectInputWrapper));
